export default class Redirect {
    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind() {

            this.$view.on('click','.redirect', function (event) {

                    event.preventDefault();
                    event.stopImmediatePropagation();
                    var target = event.currentTarget;
                    var urlRedirect = target.dataset.redirect;

                    // on deverouiile l'acces a la vv
                    HegydCore.initRemoteModal('#modal', urlRedirect, null, function(data){
                            window.location.href = data.redirect;
                        }
                        , function (data) {
                            toastr.error('Une erreur est survenue !');
                        });
              
            });

    }
}
